import React, { useState, useEffect } from 'react';
import { FLAVOR, icons } from "../../helpers/constants";
import 'dayjs/locale/sv';
import { useMapToggles } from '../Map/ToggleContext'; // Adjust the path as necessary
import { useTranslation } from "react-i18next";
import toast from 'react-hot-toast';
import InfoCardModal from '../Modals/InfoCardModal';
import InfoPill from '../Pills/InfoPill';
import { fixDate, getBatteryIcon } from '../../helpers/helperFunctions';
import PillButton from '../Buttons/PillButton';
import { useIsMobile } from '../../helpers/customHooks';
import { useNavigate } from 'react-router-dom';
import NewButton from '../Buttons/NewButton';


const DeviceRowNew = ({ index, currentDevice, setCurrentDevice, device, checkboxVisibility, setDeviceToggle, deviceListLength}) => {
    const { t } = useTranslation();
    const [modalData, setModalData] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const { setActiveDevice } = useMapToggles();
    const navigate = useNavigate()
    const MOBILE = useIsMobile();
    const status_pills = device?.status_pills 
    const vehicleinfo = device?.vehicleinfo
    const external_info = device?.external_hardwareinfo
    const iotinfo = device?.iotinfo
    const iotbattery_raw = iotinfo?.power?.battery?.info
    const iot_charging = iotinfo?.power?.charge?.info
    const bikebattery = vehicleinfo?.currentstatus?.battery?.info
    const bikecharge = vehicleinfo?.currentstatus?.battery?.charging
    const model = FLAVOR === "bike" ? vehicleinfo?.model?.name : FLAVOR === "alco" ? external_info?.model?.name : iotinfo?.model?.name;
    const positionExists = device?.hasposition
    const deviceOnline = device?.status === "online"
	const last_update = device?.lastupdate


    const showOnMap = (event, device) => {
        event.stopPropagation();
        if(!positionExists){
            toast.error(t("toast.no_position_device_show"))
        }else{
            if(MOBILE){
                navigate("/map")
            }
            setActiveDevice(device.id)
        }
 
    }
    // useEffect(() => {
    // if(deviceListLength === 1){
    //     setCurrentDevice(device?.id)
    // }
    // }, [deviceListLength])


	const infoPills = [
		{
			type: "engineblockpending_on",
			visible: status_pills?.enginblockpending_on,
			order: 2,
		},
		{
			type: "engineblock_on",
			visible: status_pills?.engineblock_on,
			order: 2,
		},
		{
			type: "override_on",
			visible: status_pills?.override_on,
			order: 2,
		},
		{
			type: "override_pending",
			visible: status_pills?.override_pending,
			order: 2,
		},
		{
			type: "online",
			visible: status_pills?.online,
			order: 2,
		},
		{
			type: "vehicle_on",
			visible: status_pills?.vehicle_on,
			order: 2,
		},
		{
			type: "sleeping",
			visible: status_pills?.sleeping,
			order: 4,
		},
		{
			type: "vehicle_off",
			visible: status_pills?.vehicle_off,
			order: 4,
		},
		// {
		//     type: "offline",
		//     visible: device?.status !== "online",
		//     order: 4
		// },
		{
			type: "no_dataplan",
			visible: status_pills?.no_dataplan,
			order: 1,
		},
		{
			type: "awaiting_connection",
			visible: status_pills?.awaiting_first_connection,
			order: 5,
		},
		{
			type: "awaiting_position",
			visible: status_pills?.awaiting_first_position,
			order: 5,
		},
		{
			type: "stolenmode",
			visible: status_pills?.stolenmode_on,
			order: 3,
		},
		{
			type: "alarmcenter_armed",
			visible: status_pills?.alarmcenter_armed,
			order: 3,
		},
		{
			type: "alarmcenter_unarmed",
			visible: status_pills?.alarmcenter_unarmed,
			order: 3,
		},
		{
			type: "alarmcenter_triggered",
			visible: status_pills?.alarmcenter_ongoingalarm,
			order: 3,
		},
	];

    const clickDevice = () => {
        if(device.id === currentDevice){
            setCurrentDevice(null)
        }else{
            setCurrentDevice(device.id)
        }
    }

    return(
        <>
        <div className={`d-flex flex-column bg-white p-3 align-items-start cursor-pointer`} onClick={() => clickDevice()}>
            <div className="d-flex w-100">
                {checkboxVisibility &&
                <div 
                    className={`me-3 align-self-center ${device?.selected ? "bg-checked" : "bg-grey"} size_20 border-sm d-flex justify-content-center p-1`} 
                    onClick={(event) => setDeviceToggle(event, device.id)}>
                    {device?.selected && <img className="white-icon" src={icons.check} alt={""} />}
                </div>
                }
                <img className="size24 align-self-center primary-icon" src={iot_charging || bikecharge ? icons.battery.battery_charge : getBatteryIcon(bikebattery ? bikebattery : iotbattery_raw)} alt=""/>
                <div className="d-flex flex-column ms-3 overflow-hidden">
                    <p className="body bold standard text-truncate me-2">{device?.name}</p>
                    <p className="">{`${model}`}</p>
                </div>
                {positionExists &&
                <NewButton 
                    notext={true} 
                    icon={icons.location_arrow} 
                    iconClass={`${deviceOnline ? "white-white-icon" : "drak-grey-icon"}`} 
                    className={`${deviceOnline ? "bg-gradient" : "bg-grey" } ms-auto full-rounded size_36`} 
                    onClick={(event) => showOnMap(event, device)} />
                }
            </div>
            <div className="d-flex mt-2">
                {infoPills
                    .filter(pill => pill.visible)
                    .sort((a, b) => a.order - b.order)
                    .map((pill, index) => (
                    <InfoPill key={index} type={pill.type} />
                ))}
            </div>
        </div>
        <hr className={`m-0 p-0 event-divider bg-light-grey ${index === deviceListLength - 1 ? "d-none" : "" }`} />
     
            <InfoCardModal show={showModal} data={modalData} onClose={() => setShowModal(!showModal)} />
            {/* <ExtendedInfoModal show={showExtendedModal} type={extendedType} data={extendedData} onClose={() => setShowExtendedModal(!showExtendedModal)} turnOffStolenMode={() => turnOffStolenMode()}/>
            <ZoneModal show={showZoneModal} triggered={device.modelspecificinfo?.alarmcenter?.triggered} deactivateAlarm={() => toggleAlarm(false)} activateAlarm={() => toggleAlarm(true)} device={device} onClose={() => setShowZoneModal(false)} /> */}
        </>
        
    )
}

export default DeviceRowNew;